export const responseDataSelector = (model) => model?.data?.data?.data;
export const responseCodeSelector = (model) => model?.data?.data?.status;
export const responseMessageSelector = (model) => model?.data?.data?.message;

export const errorSelector = (model) => model?.error;
export const errorCodeSelector = (model) => model?.error?.response?.data?.status;
export const errorMessageSelector = (model) => model?.error?.response?.data?.mensaje;

export const responseSelector = (response) => ({
  data: response?.data?.data?.data,
  status: response?.data?.data?.status,
  message: response?.data?.data?.message || response?.data?.data?.mensaje,
  error: response?.error
    ? {
        code: response?.error?.response?.data?.status,
        message: response?.error?.response?.data?.mensaje,
      }
    : undefined,
});
